var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.props.route.routeName())?_c('h1',{staticClass:"heading"},[_vm._v(_vm._s(_vm.props.route.routeName().toUpperCase()))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }